import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './warranty-conditions-line.scss';

export function WarrantyConditionsLine({ color, children, className = '' }) {
  return (
    <div className={classnames('warranty-conditions-line d-flex align-items-center', className)}>
      <span className={classnames('warranty-conditions-line-color-chip', color)} />
      <p className="mb-0 ms-0_5 size-14">{children}</p>
    </div>
  );
}

WarrantyConditionsLine.propTypes = {
  color: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
